import { render, staticRenderFns } from "./PiiRedactor.vue?vue&type=template&id=62c7c475&"
import script from "./PiiRedactor.vue?vue&type=script&lang=js&"
export * from "./PiiRedactor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports